// built-in imports
import { useLocation } from "react-router-dom";

// internal imports
import { useAppContext } from "../../layout/layout";
import { navigation } from "../../utils/data/data.utils";
import { Wrapper } from "./navigation.component.styles";

const Navigation = () => {
  const { setIsHover, lang, activeMenu } = useAppContext();

  const renderNav = (nav) => {
    return (
      <li
        key={nav.id}
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
      >
        <a
          href={nav.path}
          className={`menue ${activeMenu === nav.nemuId ? "activeLink" : ""}`}
        >
          {lang === "en" ? nav.en_name : nav.de_name}
        </a>
      </li>
    );
  };

  return <Wrapper>{navigation.map((nav) => renderNav(nav))}</Wrapper>;
};
export default Navigation;
